import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConfidence95 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 25",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.79484 6.7644C3.31388 8.45155 2.41602 10.6632 2.41602 13.0845",
			stroke: "var(--success-icon-color, #00AD11)",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.55664 14.7285C3.02204 17.421 4.6108 19.7287 6.82276 21.1514",
			stroke: "var(--success-icon-color, #00AD11)",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5918 21.5001C19.1057 20.1257 20.9361 17.6576 21.4434 14.7356",
			stroke: "var(--success-icon-color, #00AD11)",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5858 13.0846C21.5858 10.7617 20.7595 8.63186 19.3848 6.9729",
			stroke: "var(--success-icon-color, #00AD11)",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4125 5.96017C16.7142 4.43081 14.4662 3.5 12.0008 3.5C9.67411 3.5 7.54101 4.32908 5.88086 5.70794",
			stroke: "var(--success-icon-color, #00AD11)",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.87 9.55C9.59 9.55 10.1833 9.80667 10.65 10.32C11.1167 10.8267 11.35 11.49 11.35 12.31C11.35 13.43 11.01 14.4 10.33 15.22C9.65 16.0333 8.76667 16.5433 7.68 16.75L7.28 15.65C8.56667 15.2967 9.40333 14.6567 9.79 13.73L9.78 13.72C9.39333 13.9333 8.96667 14.04 8.5 14.04C7.90667 14.04 7.41 13.8433 7.01 13.45C6.61 13.0567 6.41 12.52 6.41 11.84C6.41 11.1667 6.64333 10.6167 7.11 10.19C7.57667 9.76333 8.16333 9.55 8.87 9.55ZM7.74 11.86C7.74 12.1667 7.84 12.4167 8.04 12.61C8.24 12.8033 8.51333 12.9 8.86 12.9C9.32 12.9 9.71667 12.6967 10.05 12.29V12.2C10.05 11.7733 9.94 11.43 9.72 11.17C9.5 10.91 9.22333 10.78 8.89 10.78C8.55 10.78 8.27333 10.8867 8.06 11.1C7.84667 11.3067 7.74 11.56 7.74 11.86ZM15.3942 12.07C15.9942 12.07 16.5009 12.2733 16.9142 12.68C17.3276 13.0867 17.5342 13.62 17.5342 14.28C17.5342 14.9533 17.2976 15.5067 16.8242 15.94C16.3576 16.3667 15.7742 16.58 15.0742 16.58C14.0676 16.58 13.2776 16.22 12.7042 15.5L13.6842 14.71C14.0042 15.13 14.4442 15.34 15.0042 15.34C15.3309 15.34 15.6042 15.2367 15.8242 15.03C16.0442 14.8233 16.1542 14.5667 16.1542 14.26C16.1542 13.92 16.0342 13.6567 15.7942 13.47C15.5542 13.2767 15.2809 13.18 14.9742 13.18C14.5809 13.18 14.2376 13.2967 13.9442 13.53L13.2242 13.26L13.4342 9.63H17.1842V10.87H14.6142L14.5342 12.22C14.8542 12.12 15.1409 12.07 15.3942 12.07Z",
			fill: "var(--label-color, #475B5E)"
		})
	]
});
export default SvgConfidence95;
